<template>
  <div>
    当前在线的，未注册的智能中转柜
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="sn"
        label="设备序列号"
        width="150">
      </el-table-column>
      <el-table-column
        prop="ip"
        label="IP"
        width="350">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="registerTerminalShow(scope.$index, tableData)"
            size="mini" type="success" >
            注册此设备
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="设备注册" :visible.sync="registerTerminalVisible">
      <el-form :model="form">
        <el-form-item label="序列号" :label-width="formLabelWidth">
          <el-input v-model="form.sn" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="IP" :label-width="formLabelWidth">
          <el-input v-model="form.ip" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="名字" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input v-model="form.addr" autocomplete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="registerTerminalVisible = false">取 消</el-button>
        <el-button type="primary" @click="registerTerminal" :loading="registerTerminalSending">注册设备</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import coder from "./enum.js"
  export default {
    methods: {
      registerTerminalShow(index, rows) {
        console.log("registerTerminalShow:",index,rows);
        this.form={
          sn:rows[index].sn,
          ip:rows[index].ip,
          name: '',
          addr:''
        };
        this.registerTerminalVisible=true;
      },
      registerTerminal(index, rows) {
        console.log("registerTerminal:",index,rows);
        if (this.form.name===''){
          this.$alert('请输入名称', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.addr===''){
          this.$alert('请输入地址', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.sn==='' || this.form.ip===''){
          this.$alert('设备信息错误，请检查', '错误', {
            confirmButtonText: '确定'
          });
          return
        }

        let $this=this;
        window.ws.AddFunc("S2W_RegisterTerminalRes",function (code,err) {
          if (code===coder.OK){
            $this.$notify({
              title: '成功',
              message: '注册设备成功',
              type: 'success'
            });
            $this.registerTerminalVisible=false;
            window.ws.Call("W2S_GetNotRegisterTerminal",$this.page,$this.pageSize);
          }else{
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }
        });
        window.ws.Call("W2S_RegisterTerminal",this.form.sn,this.form.name,this.form.addr);
      },
      handleSizeChange(e){
        this.pageSize=e;
        window.ws.Call("W2S_GetNotRegisterTerminal",this.page,this.pageSize);
      },
      handleCurrentChange(e){
        this.page=e;
        window.ws.Call("W2S_GetNotRegisterTerminal",this.page,this.pageSize);
      }
    },
    mounted() {
      let $this=this;
      window.ws.AddFunc("S2W_GetNotRegisterTerminalRes",function (code,err,currentPage,total,list) {
        console.log("S2W_GetNotRegisterTerminalRes:",code,err,currentPage,total,list)
        if (code==coder.OK){
          $this.page=currentPage;
          $this.total=total;
          $this.tableData=list;
        }else{
          $this.$alert(err+'('+code+')', '错误', {
            confirmButtonText: '确定'
          });
        }
      });
      window.ws.Call("W2S_GetNotRegisterTerminal",$this.page,$this.pageSize);
    },
    data() {
      return {
        registerTerminalSending:false,
        registerTerminalVisible:false,
        formLabelWidth:"120px",
        page:1,
        pageSize:10,
        total:0,
        tableData: [],
        form: {
          sn:'',
          ip:'',
          name: '',
          addr:''
        },
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/registerTerminal.vue